export default __webpack_public_path__ + "static/media/colors-sandStoneMocha.a3c08368.jpg";